import $ from "jquery";

$(function() {
  if ($(".c-sticky").length || $(".gridelement.button-container").length) {
    $("body").addClass("has-sticky-footer");
  }
});
